import React from 'react';
import { CartoonPortrait } from './CartoonPortrait';
interface FigureProps {
  className?: string;
}
export function YoungestFigure({
  className = ''
}: FigureProps) {
  return <CartoonPortrait className={className} label="Cartoon portrait of an energetic, spontaneous youngest sibling" disc="#05DD4D" skin="#8D5A3B" skinShade="#7A4C31" hair="#12211C" shirt="#FBF7F0" hairStyle="curlyAfro" mouth="grin" motif="sparkles" tilt={4} data-id="element-77" data-mp="2spy0ol6qn3oq" />;
}